import React, { Component } from "react";
import axios from 'axios'
import SelectNegozi from "./SelectNegozi";
import { Table, Space, DatePicker } from "antd";
import moment from 'moment'
import MonthlySubTable from './MonthlySubTable'
import SelectInterval from "./SelectInterval";
import MyResponsivePie from './Torta'
import ArticlesSubTable from "./ArticlesSubTable";

const { RangePicker } = DatePicker;


export default class NegoziTable extends Component {
    constructor(props) {
        console.log(props.negozio)
        super(props);
        this.state = {
            dataSource: [],
            interval: "year",
            shop: props.negozio === "admin" ? "all" : props.negozio,
            role: props.negozio === "admin" ? "all" : props.negozio,
            daily: [],
            start: moment().subtract(1, 'month').toISOString(),
            end: new Date().toISOString()
        };

        this.changeInterval = this.changeInterval.bind(this)
        this.selectNegozio = this.selectNegozio.bind(this)
        this.onDateChange = this.onDateChange.bind(this)
    }

    componentDidMount() {
        this.fetchShopsData()
    }

    fetchShopsData() {
        this.setState({ dataSource: null });
        if (this.state.role === "all") {
            return axios
                .get(
                    `${process.env.REACT_APP_SERVER_URL}/api/dati/shops_interval?start=${this.state.start}&end=${this.state.end}&interval=${this.state.interval}`
                )
                .then((response) => {
                    console.log(response.data.dateFilter.buckets[0].negozi)
                    this.setState({ dataSource: response.data.dateFilter.buckets[0].negozi.buckets }, () => { console.log(this.state.dataSource) })
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
                .then(() => {
                    // always executed
                });

        } else {
            return axios
                .get(
                    `${process.env.REACT_APP_SERVER_URL}/api/dati/shops_interval/${this.state.shop}?start=${this.state.start}&end=${this.state.end}&interval=${this.state.interval}`
                )
                .then((response) => {
                    console.log(response.data.dateFilter.buckets[0].negozi)


                    let record = {
                        'key': this.state.shop,
                        'per_negozio': {
                            'buckets': response.data.dateFilter.buckets[0].negozi.per_negozio.buckets
                        }
                    };

                    this.setState({ dataSource: [record]}, () => { console.log(this.state.dataSource) })
                })
                .catch((error) => {
                    // handle error
                    console.log(error);
                })
                .then(() => {
                    // always executed
                });


        }
    }


    changeInterval(interval) {
        this.setState({ interval }, () => {
            this.fetchShopsData()
        })

    }

    selectNegozio(shop) {

        this.setState({ shop })

        if (shop === "all") {
            this.fetchShopsData()
        } else {

            this.fetchShopsData().then(() =>
                this.setState({ dataSource: this.state.dataSource.filter(negozio => negozio.key === shop) })
            )
        }

    }

    onDateChange(dates) {

        this.setState({ start: dates[0].format("YYYY-MM-DD"), end: dates[1].format("YYYY-MM-DD") }, () => {
            this.fetchShopsData()
        })
    }

    render() {

        const yearly_columns = [
            {
                title: "Negozio",
                dataIndex: "key",
                key: "key",
                render: (text, row) => (
                    <Space size="middle" key={row.key}>
                        { row.key !== "" ? <p>{row.key}</p> : <p>Transazioni non collegate ad un negozio</p>}
                    </Space>
                )
            }
            // ,
            // {
            //     title: "Negozio",
            //     dataIndex: "key",
            //     key: "key"
            // }
        ]
        const dateFormat = "YYYY-MM-DD"

        return (
            <div id="analytics">

                <div id="analytics_range_picker">

                    <RangePicker
                        defaultValue={[moment(this.state.start, dateFormat), moment(this.state.end, dateFormat)]}
                        onChange={this.onDateChange}
                        format={"DD-MM-YYYY"}
                    />

                </div>

                <div id="analytics_filters">
                    <SelectNegozi role={this.state.role} negozio={this.state.shop} selectNegozio={this.selectNegozio} />
                    <SelectInterval changeInterval={this.changeInterval} />
                </div>


                <div id="analytics_torta">
                    <MyResponsivePie shop={this.state.shop} start={this.state.start} end={this.state.end} />
                </div>

                <h3> Riassunto negozi </h3>
                <Table id="analytics_table" pagination={true} dataSource={this.state.dataSource} expandable={{
                    expandedRowRender: record => <MonthlySubTable pagination={true} data={record.per_negozio.buckets} negozio={record.key} interval={this.state.interval} />

                }} columns={yearly_columns} />

                <h3> Negozio / Articoli </h3>
                <ArticlesSubTable interval={this.state.interval} start={this.state.start} end={this.state.end} negozi_columns={yearly_columns} shop={this.state.shop} />

            </div>
        )
    }

}
